/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import Select from "@material-ui/core/Select";
import { withTheme } from "@material-ui/core/styles";

import styled from "styled-components";

const StyledSelectDisabled = styled(({ theme, ...otherProps }) => (
  <Select {...otherProps} />
))`
  .MuiOutlinedInput-root&:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) =>
      props.error ? undefined : props.theme.palette.primary.main} !important;
    color: ${(props) =>
      props.error ? undefined : props.theme.palette.primary.main};
  }
  .MuiSelect-root {
    background-color: inherit;
    color: ${(props) => props.theme.palette.primary.dark} !important;
  }

  .MuiSvgIcon-root {
    display: none;
  }
`;

export default withTheme(StyledSelectDisabled);
